import utility from './utility'

const managePayments = {
    init: function () {
        const manageCards = document.getElementById("account--manage-cc");
        if (manageCards) {
            new this.manageCCActions(manageCards);
        }

        const manageBankAcc = document.getElementById("account--manage-bankacc");
        if (manageBankAcc) {
            new this.manageBankAccActions(manageBankAcc);
        }

        const deletePaymentContinue = document.getElementById("account--query-delete-payment-continue");
        if (deletePaymentContinue) {
            deletePaymentContinue.onclick = (e) => {
                this.deletePaymentMethod(e.currentTarget, e.currentTarget.dataset.id);
            };
        }

        const deletePaymentCancel = document.getElementById("account--query-delete-payment-return");
        if (deletePaymentCancel) {
            deletePaymentCancel.onclick = (e) => {
                utility.hidePopups();
            };
        }

        this.methodExpandClick();
    },

    deletePaymentMethod: function (submitButton, paymentMethod) {
        const ajaxOptions = {
            url: "/api/web/account/payment-methods/delete",
            method: "post",
            data: "customerPaymentMethodId=" + paymentMethod,
            success: function (e) {
                const result = JSON.parse(e.target.responseText);

                if (result.success) {
                    utility.enableButton(this.submitButton);
                    utility.showNotificationPopup({
                        title: "Success",
                        centreContent: true,
                        content: result.message ? result.message : "Your payment method has been deleted.",
                        hideCloseIcon: true,
                        button: {
                            url: "/account/payment-methods/"
                        }
                    });
                }
                else {
                    var msg = "An unknown error has occurred";
                    if (result.message && result.message.trim()) {
                        msg = result.message;
                    }
                    utility.showNotificationPopup({
                        title: "Error",
                        content: msg
                    });
                }
            },
            always: function () {
                utility.enableButton(submitButton);
            }
        };
        utility.disableButton(submitButton);
        utility.ajaxRequest(ajaxOptions);
    },

    manageCCActions: class {
        constructor(manageCards) {
            this.submitButtons = [...manageCards.querySelectorAll('button[type="button"], button[type="submit"]')];
            this.paymentMethods = [...document.querySelectorAll(".account--manage-methods .payment-methods")];
            this.activePaymentMethod = "";
            this.checkBraintreeHostedFields = false;
            this.checkBraintreeHostedFormValid = false;
            this.submitButtons.map(submitButton => {
                submitButton.onclick = (el) => {
                    const button = el.currentTarget;
                    if (button.dataset.action === "delete") {
                        this.deleteCreditCard(button);
                    }
                };
            });

            this.paymentMethods.map(paymentMethod => {
                paymentMethod.onclick = (el) => {
                    if (!el.currentTarget.classList.contains('active')) {
                        this.paymentMethods.map(pm => utility.removeClass(pm, "active")) && utility.addClass(el.currentTarget, "active");
                        this.handleMethodChange(el.currentTarget);
                        this.activePaymentMethod = el.currentTarget;                  
                    }
                }
            });
        }

        addCreditCard(deviceData, nonce) {
            let form = document.getElementById('new-paypal-hosted-field');
            let submitButton = document.getElementById('new-credit-card');

            const ajaxOptions = {
                url: "/api/web/account/payment-methods/save-credit-card",
                method: "post",
                data: "BTRPaymentNonce=" + encodeURIComponent(nonce) + "&BTRDeviceData=" + deviceData,
                success: function (e) {
                    utility.removeFormInputErrors(form);
                    const result = JSON.parse(e.target.responseText);
                    if (result.result === "S") {
                        utility.enableButton(this.submitButton);
                        utility.showNotificationPopup({
                            title: "Success",
                            centreContent: true,
                            content: "Your credit card has been saved.",
                            hideCloseIcon: true,
                            button: {
                                url: "/account/payment-methods/"
                            }
                        });
                    }
                    else if (result.result === "E") {
                        utility.showNotificationPopup({
                            title: "Error",
                            content: result.message
                        });
                    }
                    else if (result.result === "F") {
                        result.fieldErrors.map(error => {
                            utility.addFormInputError(form, error.Name, error.Error);
                        });
                    }
                    else {
                        utility.showNotificationPopup({
                            title: "Error",
                            content: "An unknown error has occurred"
                        });
                    }
                },
                error: function () {
                    utility.removeFormInputErrors(form);
                },
                always: function () {
                    utility.enableButton(submitButton);
                }
            };
            utility.disableButton(submitButton);
            utility.ajaxRequest(ajaxOptions);
        }

        updateCreditCard(deviceData, nonce, customerPaymentMethodId) {
            let form = this.activePaymentMethod.querySelector("form");
            let updateBtn = form.querySelector("button[data-action='update']");

            const ajaxOptions = {
                url: "/api/web/account/payment-methods/update-credit-card",
                method: "post",
                data: "BTRPaymentNonce=" + encodeURIComponent(nonce) + "&BTRDeviceData=" + deviceData + "&customerPaymentMethodId=" + customerPaymentMethodId,
                success: function (e) {
                    utility.removeFormInputErrors(form);
                    const result = JSON.parse(e.target.responseText);
                    if (result.result === "S") {
                        utility.enableButton(this.submitButton);
                        utility.showNotificationPopup({
                            title: "Success",
                            centreContent: true,
                            content: "Your credit card has been updated.",
                            hideCloseIcon: true,
                            button: {
                                url: "/account/payment-methods/"
                            }
                        });
                    }
                    else if (result.result === "E") {
                        utility.showNotificationPopup({
                            title: "Error",
                            content: result.message
                        });
                    }
                    else if (result.result === "F") {
                        result.fieldErrors.map(error => {
                            utility.addFormInputError(form, error.Name, error.Error);
                        });
                    }
                    else {
                        utility.showNotificationPopup({
                            title: "Error",
                            content: "An unknown error has occurred"
                        });
                    }
                },
                error: function () {
                    utility.removeFormInputErrors(form);
                },
                always: function () {
                    utility.enableButton(updateBtn);
                }
            };
            utility.disableButton(updateBtn);
            utility.ajaxRequest(ajaxOptions);
        }

        deleteCreditCard(submitButton) {
            const form = utility.findAncestorType(submitButton, "form");
            const id = form.querySelector("input[name='customerPaymentMethodId']").value;
            document.getElementById("account--query-delete-payment-continue").dataset.id = id;
            utility.showPopup(document.getElementById("account--query-delete-payment-popup"));
        }

        handleMethodChange(paymentOption) {
            utility.removeFormInputErrors(paymentOption);
            //Create PayPal button if 'Add PayPal'
            if (paymentOption.dataset.paymentmethod === "4001" && !paymentOption.classList.contains('saved')) {
                let saveInWithdraw = paymentOption.dataset.withdrawmethod;
                if (saveInWithdraw == 'true')
                {
                  this.handlePayPalVault('payPalSaveInWithdraw');
                }
                else
                {
                  this.handlePayPalVault();
                }                
            } else if (paymentOption.dataset.paymentmethod === "1001") {
                // New credit card
                if (!this.checkBraintreeHostedFields) {
                    this.handlePayPalVault('hosted')
                } 
                if (!this.checkBraintreeHostedFormValid) {
                    // disable HF submit if form invalid
                    let submit = document.getElementById('new-credit-card');
                    submit.setAttribute("disabled", "disabled");
                } 

            }
            // Saved credit card EDIT
            if (paymentOption.classList.contains('saved') && (paymentOption.classList.contains('Mastercard') || paymentOption.classList.contains('Visa'))) {
                let form = paymentOption.querySelector("form");
                //Edit Credit Card, dont invocate paypal if already edited once
                if (!paymentOption.classList.contains('paypal-active')) {
                    this.disableSubmitButtons();
                    this.handlePayPalVault('edithosted')
                }

                if (form.classList.contains('paypal-invalid')) {
                    // disable HF submit if form invalid
                    let updateBtn = paymentOption.querySelector("button[type='submit']");
                    updateBtn.setAttribute("disabled", "disabled");
                } 

            }
        }

        createHostedFields(deviceData, clientInstance) {
            let that = this;
            that.enableSubmitButtons();
            let form = document.getElementById('new-paypal-hosted-field');
            let submit = document.getElementById('new-credit-card');
            let loader = document.getElementById('bt-loader-manage');
            let formloader = document.getElementById('bt-form-manage');  
            submit.setAttribute("disabled", "disabled");

            braintree.hostedFields.create({
                preventAutofill: false,
                client: clientInstance,
                styles: {
                    input: {
                        'input': 'hosted-fields',
                        'font-size': '1rem',
                        color: '#2C68A5'
                    },
                    'input.invalid': {
                        'color': 'red'
                    },
                    //'input.valid': {
                    //    'color': 'green'
                    //}
                },
                fields: {
                    number: {
                        supportedCardBrands: {
                            visa: true,
                            'master-card': true
                        },
                        container: '.hosted-field-card-number',
                        placeholder: 'Enter your card number'
                    },
                    cardholderName: {
                        selector: '.hosted-field-card-name',
                        placeholder: 'Name as it appears on your card'
                    },
                    cvv: {
                        container: '.hosted-field-cvv',
                        placeholder: 'Enter valid 3-digit CVV'
                    },
                    expirationDate: {
                        container: '.hosted-field-expiration-date',
                        placeholder: 'MM/YYYY'
                    }
                }
            }, function (hostedFieldsErr, hostedFieldsInstance) {
                if (hostedFieldsErr) {
                    let error = `There was an error when trying to add a new card.<br/>Please try again.`;
                    utility.logError("Manage Payments: Error creating client", hostedFieldsErr, function () {
                        that.handlePayPalError(error);
                    });
                    return;
                }

                //hide loader, show form
                if (loader) {
                    loader.style.display = 'none';
                }
                if (formloader) {
                    utility.removeClass(formloader, "disabled");
                }

                // Set auto focus on card number
                hostedFieldsInstance.focus('number', function (focusErr) {
                    if (focusErr) {
                        console.error(focusErr);
                    }
                });

                hostedFieldsInstance.on('blur', function (event) {
                    var field = event.fields[event.emittedBy];
                    var container = field.container;
                    var label = container.nextElementSibling;

                    if (field.isEmpty) {
                        utility.addClass(label, "show");
                        utility.addClass(container, "is-invalid");
                    }
                    else {
                        utility.removeClass(label, "show");
                        utility.removeClass(container, "is-invalid");

                    }
                });

                // check validity and enable submit
                hostedFieldsInstance.on('validityChange', function (event) {
                    var allValid = true;
                    var key;
                    for (key in event.fields) {
                        utility.removeClass(event.fields[key].container, "is-invalid");
                        var label = event.fields[key].container.nextElementSibling;
                        if (label) {
                            utility.removeClass(label, "show");
                        }

                        if (event.fields[key].isValid === false) {
                            utility.addClass(event.fields[key].container, "is-invalid");
                            if (label) {
                                utility.addClass(label, "show");
                            }
                            allValid = false;
                            break;
                        }

                    }

                    if (allValid) {
                        submit.removeAttribute('disabled');
                        that.checkBraintreeHostedFormValid = true;
                    } else {
                        submit.setAttribute("disabled", "disabled");
                        that.checkBraintreeHostedFormValid = false;
                    }
                });
                // check for unsupported card types - UI update to inform user TODO

                form.addEventListener('submit', function (event) {
                    event.preventDefault();
                    var state = hostedFieldsInstance.getState();
                    var formValid = Object.keys(state.fields).every(function (key) {
                        return state.fields[key].isValid;
                    });

                    if (formValid) {// Tokenize Hosted Fields
                        hostedFieldsInstance.tokenize(function (tokenizeErr, payload) {
                            if (tokenizeErr) {
                                 let error = `There was an error when submitting your card.<br/>Please try again.`;
                                utility.logError("Manage Payments: createHostedFields Tokenize Error", tokenizeErr, function () {
                                    that.handlePayPalError(error);
                                });
                                return;
                            }

                            //add vault credit card
                            that.addCreditCard(deviceData, payload.nonce)
                        });
                    } else {
                        utility.disableButton(submit);
                    }
                }, false);
                that.checkBraintreeHostedFields = true;
        });
        }

        editHostedFields(deviceData, clientInstance) {
            console.log("editHostedFields triggered");
            let that = this;
            let form = this.activePaymentMethod.querySelector("form");
            let updateBtn = form.querySelector("button[type='submit']");
            let customerPaymentMethodId = form.querySelector("input[name='customerPaymentMethodId']").value;

            that.enableSubmitButtons();
            utility.addClass(form, "paypal-invalid");
            updateBtn.setAttribute("disabled", "disabled");

            braintree.hostedFields.create({
                preventAutofill: false,
                client: clientInstance,
                styles: {
                    input: {
                        'input': 'hosted-fields',
                        'font-size': '1rem',
                        color: '#2C68A5'
                    },
                    'input.invalid': {
                        'color': 'red'
                    },
                },
                fields: {
                    expirationDate: {
                        container: `#edit-${customerPaymentMethodId}`,
                        placeholder: 'MM/YYYY'
                    }
                }
            }, function (hostedFieldsErr, hostedFieldsInstance) {
                if (hostedFieldsErr) {
                    let error = `There was an error when trying to update card.<br/>Please try again.`;
                    utility.logError("Manage Payments: editHostedFields Error", hostedFieldsErr, function () {
                        that.handlePayPalError(error);
                    });
                    return;
                }
                hostedFieldsInstance.focus('expirationDate', function (focusErr) {
                    if (focusErr) {
                        console.error(focusErr);
                    }
                });
                //hostedFieldsInstance.on('empty', function (event) {
                //    console.log(that.deleteclicked)
                //    var field = event.fields[event.emittedBy];
                //    var container = field.container;
                //    var label = container.nextElementSibling;

                //    if (field.isEmpty) {
                //        utility.addClass(label, "show");
                //        utility.addClass(container, "is-invalid");
                //    }
                //    else {
                //        utility.removeClass(label, "show");
                //        utility.removeClass(container, "is-invalid");
                //    }
                //});

                // check validity and enable submit
                hostedFieldsInstance.on('validityChange', function (event) {
                    var allValid = true;
                    var key;
                    var field = event.fields[event.emittedBy];
                    var container = field.container;
                    var label = container.nextElementSibling;
                    for (key in event.fields) {
                        if (event.fields[key].isValid === false) {
                            allValid = false;
                            break;
                        }
                    }

                    if (allValid) {
                        updateBtn.removeAttribute('disabled');
                        utility.removeClass(form, "paypal-invalid");
                        utility.addClass(form, "paypal-valid");
                        utility.removeClass(label, "show");
                        utility.removeClass(container, "is-invalid");

                    } else {
                        updateBtn.setAttribute("disabled", "disabled");
                        utility.removeClass(form, "paypal-valid");
                        utility.addClass(form, "paypal-invalid");
                        utility.addClass(label, "show");
                        utility.addClass(container, "is-invalid");
                    }
                });

                form.addEventListener('submit', function (event) {
                    event.preventDefault();
                    var state = hostedFieldsInstance.getState();
                    var formValid = Object.keys(state.fields).every(function (key) {
                        return state.fields[key].isValid;
                    });

                    if (formValid) {// Tokenize Hosted Fields
                        hostedFieldsInstance.tokenize(function (tokenizeErr, payload) {
                            if (tokenizeErr) {
                                let error = `There was an error when trying to update card.<br/>Please try again.`;
                                utility.logError("Manage Payments editHostedFields Submit: tokenizeErr", tokenizeErr, function () {
                                    that.handlePayPalError(error);
                                });
                                return;
                            }
                             console.log('Got a nonce: ' + payload.nonce);
                            //add vault credit card
                            that.updateCreditCard(deviceData, payload.nonce, customerPaymentMethodId)
                        });
                    } else {
                        utility.disableButton(updateBtn);
                    }
                }, false);           

                //add a class to stop re invocating hosted fields
                utility.addClass(that.activePaymentMethod, "paypal-active");
            });
        }

        addPayPalAccount(deviceData, nonce) {

            let selectedPaymentOption = this.activePaymentMethod;
            const ajaxOptions = {
                url: "/api/web/account/payment-methods/save-hosted",
                method: "post",
                data: "PaymentMethodId=4001&BTRPaymentNonce=" + encodeURIComponent(nonce) + "&BTRDeviceData=" + deviceData,
                success: function (e) {
                    utility.removeClass(selectedPaymentOption, "disabled")

                    const result = JSON.parse(e.target.responseText);
                    if (result.result === "S") {
                        utility.showNotificationPopup({
                            title: "Success",
                            centreContent: true,
                            content: "Your PayPal account has been saved.",
                            hideCloseIcon: true,
                            button: {
                                url: "/account/payment-methods/"
                            }
                        });
                    }
                    else if (result.result === "E") {
                        utility.showNotificationPopup({
                            title: "Error",
                            content: result.message,
                            hideCloseIcon: true,
                            button: {
                                url: "/account/payment-methods/"
                            }
                        });
                    }   
                    else {
                        utility.showNotificationPopup({
                            title: "Error",
                            content: result.message ? result.message : "An unknown error has occurred",
                            hideCloseIcon: true,
                            button: {
                                url: "/account/payment-methods/"
                            }
                        });
                    }
                },
            };
            utility.addClass(selectedPaymentOption, "disabled");
            utility.ajaxRequest(ajaxOptions);
        }

        handlePayPalVault(action) {
            let savePayPal = true;
            let getClientTokenApi;
            let payPalLoading = document.getElementById("paypal-button-save");
            let payPalRenderId = '#paypal-button-save';
            if (action && action == 'payPalSaveInWithdraw') {
                //if paypal vault via withdraw
                payPalLoading = document.getElementById("paypal-button-withdraw");
                payPalRenderId = '#paypal-button-withdraw';
            }
            
            //change api call for hostedfield 
            if (action && (action == 'hosted' || action == 'edithosted')) {
                getClientTokenApi = `/api/web/account/payment-methods/braintree/get-client-token?paymentmethodid=1001&save=${savePayPal}`;   
            } else {
                getClientTokenApi = `/api/web/account/payment-methods/braintree/get-transaction-client?paymentmethodid=4001&save=${savePayPal}`;            
            }
            if (payPalLoading) {
                payPalLoading.innerHTML = `<p class='text-center'>Loading PayPal...</p>`;
            }

            let that = this;

            fetch(getClientTokenApi, { method: 'GET' })
                .then(response => response.json())
                .then(response => {
                    if (response.Success) {
                        braintree.client.create({
                            authorization: response.ClientToken
                        }, function (clientErr, clientInstance) {
                            if (clientErr) {
                                 let error = `There was an error when trying to add a new card.<br/>Please try again.`;
                                utility.logError("Paypal MP: Error creating client", clientErr, function () {
                                    that.handlePayPalError(error);
                                });
                                return;
                            }

                            // Data Collector
                            braintree.dataCollector.create({
                                client: clientInstance,
                                clientMetadataId: response.ClientMetaDataId
                            }, function (err, dataCollectorInstance) {
                                let deviceData = "";
                                if (err) {
                                    utility.logError("Paypal MP: DataCollector Error", err, null);
                                    if (!action || action != 'hosted' && action != 'edithosted') {
                                        let error = `There was an error. Please turn off any adblockers or VPNs and try again.`;
                                        that.handlePayPalError(error);
                                        return;
                                    }
                                }
                                else {
                                    deviceData = dataCollectorInstance.deviceData;
                                }

                                if (action == 'hosted') {
                                // New Credit Card (using clientInstance only to save on api call - backend)
                                    that.createHostedFields(deviceData, clientInstance);
                                }
                                else if (action == 'edithosted') {
                                    that.editHostedFields(deviceData, clientInstance);
                                }
                                else {                                    
                                    beginPayPalCheckout(deviceData, response.ClientMetaDataId)
                                }

                            });

                            function beginPayPalCheckout(deviceData, clientMetaDataId) {
                                // Create PayPal Buttons
                                const btnStyle = {
                                    layout: 'vertical',
                                    color: 'blue',
                                    shape: 'pill',
                                    label: 'paypal',
                                    disableMaxWidth: true,
                                };
                      
                                const paypalVaultConfig = {
                                    flow: 'vault', // Required
                                    riskCorrelationId: clientMetaDataId
                                };

                                // Create a PayPal Vault Component.
                                braintree.paypalCheckout.create({
                                        client: clientInstance
                                    }, function (paypalCheckoutErr, paypalCheckoutInstance) {
                                        if (paypalCheckoutErr) {
                                            let error = `There was an error creating PayPal Checkout.`;
                                            utility.logError("MP paypalCheckoutErr", paypalCheckoutErr, function () {
                                                that.handlePayPalError(error);
                                            });
                                            if (payPalLoading) {
                                                payPalLoading.innerHTML = 'Error creating PayPal Checkout';
                                            }
                                            return;
                                        }
                                        // Load the PayPal JS SDK (see Load the PayPal JS SDK section)
                                        paypalCheckoutInstance.loadPayPalSDK({
                                            vault: true
                                        }, function () {
                                            const paypal = window.paypal;
                                            if (payPalLoading) {
                                                payPalLoading.innerHTML = '';
                                            }
                                                paypal &&
                                                    paypal.Buttons({
                                                        fundingSource: paypal.FUNDING.PAYPAL,
                                                        style: btnStyle,                               

                                                        createBillingAgreement: function () {
                                                            return paypalCheckoutInstance.createPayment(paypalVaultConfig);
                                                        },
                                                        onApprove: function (data, actions) {
                                                          //  console.log("onApprove Fired");
                                                            return paypalCheckoutInstance.tokenizePayment(data, function (err, payload) {
                                                             //   console.log("NONCE Vault Only", payload.nonce);                                                               
                                                                that.addPayPalAccount(deviceData, payload.nonce)
                                                            });
                                                        },

                                                        onCancel: function (data) {
                                                            console.log('PayPal payment canceled', JSON.stringify(data, 0, 2));
                                                        },

                                                        onError: function (err) {
                                                            let error = `Paypal Error. Please contact customer support`;
                                                            utility.logError("MP paypalCheckoutInstance.loadPayPalSDK Error", err, function () {
                                                                that.handlePayPalError(error);
                                                            });
                                                        }
                                                    }).render(payPalRenderId).then(function () {
                                                        console.log("Button Created");
                                                    });

                                            });
                                    });                             
                            }
                           
                        });
                    } else {
                        utility.logError("Manage Payments: Fetch getClientTokenApi failed", response.Message, function () {
                            utility.showNotificationPopup({
                                title: "Error", content: `<p class='text-center'>${response.Message}</p>`, hideCloseIcon: true,
                                centreContent: true,
                                button: {
                                    text: "OK",
                                    url: "/account/payment-methods/"
                                }
                            });
                        });
        
                    }
                }).catch((error) => {
                    //Unauthorized 
                    utility.showLoginPopup();
                });
        }

        handlePayPalError(error) {
            if (!error) {
                error = `<p>Something went wrong.</p><p>Please contact Customer Support.</p>`
            }
            utility.showNotificationPopup(
                {
                    title: "Error", content: error, hideCloseIcon: true,
                    centreContent: true,
                    button: {
                        text: "OK",
                        url: "/account/payment-methods/"
                    }
                }
            );

        }

        disableSubmitButtons() {
             this.submitButtons.map(b => utility.disableButton(b));
        }

        enableSubmitButtons() {
             this.submitButtons.map(b => utility.enableButton(b));
        }
    },

    manageBankAccActions: class {
        constructor(manageBankAcc) {
            const submitButtons = [...manageBankAcc.querySelectorAll('button[type="button"]')];
            submitButtons.map(submitButton => {
                submitButton.onclick = (el) => {
                    const button = el.currentTarget;
                    if (button.dataset.action === "add") {
                        this.addBankAccount(button);
                    }
                    else if (button.dataset.action === "delete") {
                        this.deleteBankAccount(button);
                    }
                };
            });

            const deleteButtons = [...manageBankAcc.querySelectorAll(".remove-payment")];
            deleteButtons.map(button => {
                button.onclick = (e) => {
                    document.getElementById("account--query-delete-payment-continue").dataset.id = e.currentTarget.dataset.id;
                    utility.showPopup(document.getElementById("account--query-delete-payment-popup"));
                };
            });
        }

        addBankAccount(submitButton) {
            const form = utility.findAncestorType(submitButton, "form");
            const ajaxOptions = {
                url: "/api/web/account/payment-methods/save-bank-account",
                method: "post",
                data: utility.getFormData(form),
                success: function (e) {
                    utility.removeFormInputErrors(form);
                    const result = JSON.parse(e.target.responseText);
                    if (result.result === "S") {
                        utility.enableButton(this.submitButton);
                        utility.showNotificationPopup({
                            title: "Success",
                            centreContent: true,
                            content: "Your bank account has been saved.",
                            hideCloseIcon: true,
                            button: {
                                url: "/account/payment-methods/"
                            }
                        });
                    }
                    else if (result.result === "E") {
                        utility.showNotificationPopup({
                            title: "Error",
                            content: result.message
                        });
                    }
                    else if (result.result === "F") {
                        result.fieldErrors.map(error => {
                            utility.addFormInputError(form, error.Name, error.Error);
                        });
                    }
                    else {
                        utility.showNotificationPopup({
                            title: "Error",
                            content: "An unknown error has occurred"
                        });
                    }
                },
                error: function () {
                    utility.removeFormInputErrors(form);
                },
                always: function () {
                    utility.enableButton(submitButton);
                }
            };
            utility.disableButton(submitButton);
            utility.ajaxRequest(ajaxOptions);
        }
    },

    methodExpandClick: function () {
        [...document.querySelectorAll(".account--manage-methods .payment-expand")].map(el => {
            const details = el.nextElementSibling;
            if (details && details.classList.contains("payment-content")) {
                el.onclick = () => {
                    [...document.querySelectorAll(".account--manage-methods .payment-expand")].map(el => {
                        utility.removeClass(el, "active");
                        if (el.nextElementSibling) {
                            el.nextElementSibling.style.maxHeight = 0;
                        }
                    });
                    utility.toggleClass(el, "active");
                    if (el.classList.contains('active')) {
                        details.style.maxHeight = `${details.scrollHeight + 100}px`;
                    }
                    else {
                        details.style.maxHeight = 0;
                    }
                };
            }
        });
    }
};

export default managePayments


// WEBPACK FOOTER //
// ./assets/src/js/classes/managePayments.js